import { render, staticRenderFns } from "./MacbindingViolationList.vue?vue&type=template&id=55f38fc9&"
import script from "./MacbindingViolationList.vue?vue&type=script&lang=js&"
export * from "./MacbindingViolationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports